import { CHANNELS_SALES_QUOTA_CHANNEL } from '@components/input-select-channels/src/input-select-channels.type';
import { Channel } from '@hooks/admissions/type';

export const formatChannelsToBackend = ({
  limitAllChannels,
  channelOptions,
  salesQuota,
  areAllSelected,
}: {
  limitAllChannels: string;
  salesQuota: string;
  channelOptions: {
    checked: boolean;
    value: string;
    id: string;
    name: string;
    slug: string;
  }[];
  areAllSelected: boolean;
}) => {
  let channels: Channel[] = [];
  let quantityByChannel: number | null = null;

  if (limitAllChannels) quantityByChannel = +limitAllChannels;

  if (!areAllSelected || salesQuota === CHANNELS_SALES_QUOTA_CHANNEL)
    channels = channelOptions
      .filter((channel) => channel.checked)
      .map((channel) => {
        const channelValue = channel.value === '' ? null : +channel.value;
        return {
          id: channel.id,
          maxQuantity: salesQuota === CHANNELS_SALES_QUOTA_CHANNEL ? channelValue : quantityByChannel,
        };
      });

  return channels;
};
